import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AuthService } from '../services/auth.service';

/**
 * Use on login/home (and other public) routes. If the user is already logged in,
 * redirect to dashboard and do not activate the route.
 */
export const redirectToDashboardIfAuthGuard: CanActivateFn = () => {
  const router = inject(Router);
  const authService = inject(AuthService);

  if (!authService.isAuthenticated()) {
    return true; // Not logged in, allow access to login page
  }

  const userStr = localStorage.getItem('user');
  if (userStr) {
    try {
      const user = JSON.parse(userStr);
      if (user && user.id && user.email && (user.email || '').trim().length > 0) {
        router.navigate(['/main/dashboard'], { replaceUrl: true });
        return false; // Already logged in, redirect to dashboard
      }
    } catch {
      // Invalid user data, allow access to login page
    }
  }

  return true; // No valid user in storage, allow login page
};
